// Returns the bare alias from the query string (e.g. ?onshippro → "onshippro").
// Skips standard key=value params so ?shipId=123 returns null.
export function getUrlAlias() {
    const search = window.location.search.slice(1);
    if (!search) return null;
    const firstPair = search.split('&')[0];
    if (firstPair.includes('=')) return null;
    return firstPair || null;
}

export function getParams(props) {
    const urlObj = new URLSearchParams(props.location.search.slice(1));
    return props.location.search.slice(1)
        .split('&')
        .map(p => p.split('=')).reduce((obj, pair) => {
            const [key] = pair.map(decodeURIComponent);
            return ({...obj, [key]: urlObj.get(key)});
        }, {});
}